export function isTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return Date.now() >= payload.exp * 1000;
  } catch {
    return true;
  }
}

/** For refreshTokenExpiration - a plain ISO timestamp, not a JWT. */
export function isDateExpired(isoDate: string | null | undefined): boolean {
  if (!isoDate) return true;
  const time = new Date(isoDate).getTime();
  return Number.isNaN(time) || Date.now() >= time;
}

/** Login response has no numeric user id field - only the JWT's `UserId` claim does. */
export function decodeUserId(token: string): number | null {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const id = Number(payload.UserId);
    return Number.isFinite(id) ? id : null;
  } catch {
    return null;
  }
}
